import { render, staticRenderFns } from "./ContentType.vue?vue&type=template&id=6fd8dc22&"
import script from "./ContentType.vue?vue&type=script&lang=js&"
export * from "./ContentType.vue?vue&type=script&lang=js&"
import style0 from "./ContentType.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports